<template>
  <div id="erContent">
    <tablePreview />
  </div>
</template>

<script>
import tablePreview from './components/tablePreview.vue'

export default {
  name: 'erContent',
  components: {
    tablePreview
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
